import { FormControl, FormGroup, FormLabel, Switch } from "@mui/material";

type BooleanFieldProps = {
  property: string;
  value: boolean | undefined;
  onToggle: VoidFunction;
};

export const BooleanField = ({ property, value, onToggle }: BooleanFieldProps) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{property}</FormLabel>
      <FormGroup aria-label="position" row>
        <Switch color="primary" checked={value || false} onChange={onToggle} />
      </FormGroup>
    </FormControl>
  );
};
